import { compose, lifecycle } from 'recompose'
import { connect } from 'react-redux'
import withType from 'components/common/hoc/withType'
import { getTireSizeCount } from '../helpers'
import { setTireSizeNumber } from '../actions'
import BOTAllTireSizeDetailsCartridge from './BOTAllTireSizeDetailsCartridge'

export default compose(
  withType({ type: 'BOTAllTireSizeDetailsCartridge' }),
  connect(null, { setTireSizeNumber }),
  lifecycle({
    componentDidMount() {
      this.props.setTireSizeNumber(getTireSizeCount(this.props.tireSizes))
    }
  })
)(BOTAllTireSizeDetailsCartridge)
